/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import {put, takeEvery, select, call } from '@redux-saga/core/effects';
import { getPermissionByApplicationFailure, getPermissionByApplicationSuccess } from '../actions/permissions.action';
import { GET_APPLICATION_PERMISSIONS } from 'src/types/permissions.type';
import { getPrettierMessage, sendEventToParent } from 'src/utils/global';
import { ApiRbacUrl } from 'src/utils/config';
import { ApiErrorsCodes, ApiRbacPaths } from 'src/constants/endpoints.constant';
import { parseResponse, requestApi } from 'src/providers/http-api.provider';
import { Messages } from 'src/constants/message.constant';
import Permission from 'src/models/permission.model';
import { BaseAction } from 'src/types/global.type';
import { ConfigModuleSchemaRoles } from 'src/constants/permissions.constants';

function* onGetPermissionsByApplication():any {
  try {
    const platformToken = yield select(state => state.config?.platformToken);
    if (platformToken) {
      const endpoint = `${ApiRbacUrl}${ApiRbacPaths.BASE}/permissions`;
      let response = yield call(requestApi, {
        endpoint,
        method: 'GET',
        headers: {
          Authorization: platformToken,
        },
        useParseResponse: false,
      });
      if (response?.ok) {
        let responseData = yield call(parseResponse, response);
        if(responseData?.length > 0) {
          let serviceSchemaList:any = [];
          responseData?.forEach((serviceSchema:any) => {
            const listPermissionModel = new Permission();
            const resourceGroups = listPermissionModel.getListPermissionModel(serviceSchema);
            if (resourceGroups.length > 0) {
              let serviceData:any = {
                data: resourceGroups,
                serviceId: serviceSchema?.appResource?.serviceId,
              }
              let resourceRoles:any = listPermissionModel.getSchemaDefaultRoles(serviceSchema);
              if (resourceRoles && resourceRoles?.actions?.length > 0) {
                let actions = {
                  create: resourceRoles?.actions?.find((ac:any) => ac.action?.toLowerCase() === ConfigModuleSchemaRoles.ACTION_CREATE)?.actionid || '',
                  update: resourceRoles?.actions?.find((ac:any) => ac.action?.toLowerCase() === ConfigModuleSchemaRoles.ACTION_UPDATE)?.actionid || '',
                  delete: resourceRoles?.actions?.find((ac:any) => ac.action?.toLowerCase() === ConfigModuleSchemaRoles.ACTION_DELETE)?.actionid || '',
                  view: resourceRoles?.actions?.find((ac:any) => ac.action?.toLowerCase() === ConfigModuleSchemaRoles.ACTION_VIEW ||
                    ac.action?.toLowerCase() === ConfigModuleSchemaRoles.ACTION_READ)?.actionid || '',
                };
                serviceData['defaultSchema'] = {
                  resourceId: resourceRoles?.resourceid,
                  actions,
                }
              }
              serviceSchemaList.push(serviceData);
            }
          });
          if (serviceSchemaList?.length > 0) {
            yield put(getPermissionByApplicationSuccess(serviceSchemaList));
          } else {
            throw new Error(Messages.PERMISSIONS.GET_EMPTY);
          }
        } else {
          throw new Error(Messages.ERROR_EMPTY_SCHEMAS);
        }
      } else {
        const apiError = yield call(parseResponse, response);
        if (response?.status === ApiErrorsCodes.UNAUTHORIZED) {
          throw new Error(`${getPrettierMessage(apiError?.detail)} ${Messages.AUTH_ERROR}`);
        }
        throw new Error(getPrettierMessage(apiError?.detail));
      }
    } else {
      throw new Error(Messages.PARAMS_EMPTY);
    }
  } catch (err:any) {
    console.log("Fail onGetPermissions: ", err);
    yield put(getPermissionByApplicationFailure(err?.message || Messages.ERROR_GENERIC));
  }
}

export function* watchOnGetPermissionsByApplication() {
  yield takeEvery(GET_APPLICATION_PERMISSIONS, onGetPermissionsByApplication);
}
